import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";
import { TPolicy } from "kw/types";
import { Link } from "kanopi-components/Link";
import { navigate } from "@reach/router";
import { SummaryTable } from "./SummaryTable";

type TAdminPolicySummarySection = {
  policy: TPolicy;
};
export const AdminPolicySummarySection: FC<TAdminPolicySummarySection> = ({
  policy,
}) => {
  const { formatString, formatDate } = useFormatter();

  const policyDetails = [
    {
      id: "customer",
      label: "Customer",
      value: (
        <Link
          title={`${policy?.riskProfile?.owner?.firstName} ${policy?.riskProfile?.owner?.lastName}`}
          onClick={() => navigate(`/admin/customers/${policy?.riskProfile?.owner?.id}`)}
        >
          {formatString(
            `${policy?.riskProfile?.owner?.firstName} ${policy?.riskProfile?.owner?.lastName}`
          )}
        </Link>
      ),
    },
    {
      id: "start-date",
      label: "Start date",
      value: formatDate(policy?.startDate),
    },
    {
      id: "finish-date",
      label: "End date",
      value: formatDate(policy?.finishDate),
    },
    {
      id: "payment-frequency",
      label: "Payment frequency",
      value: formatString(policy?.quote?.paymentFrequency),
    },
    {
      id: "insurer",
      label: "Insurer",
      value: formatString(policy?.quote?.product?.provider?.name),
    },
    {
      id: "product",
      label: "Product",
      value: formatString(policy?.quote?.product?.name),
    },
    {
      id: "quote-status",
      label: "Quote status",
      value: formatString(policy?.quote?.stateDisplay),
    },
    {
      id: "created",
      label: "Bound",
      value: formatDate(policy?.quote?.createdTimestamp),
    },
    {
      id: "updated",
      label: "Updated",
      value: formatDate(policy?.quote?.updatedTimestamp),
    },
  ];

  return <SummaryTable data={policyDetails} type="POLICY" />;
};
